import { render, staticRenderFns } from "./planosSemestrais.vue?vue&type=template&id=945b35d6"
import script from "./planosSemestrais.vue?vue&type=script&lang=js"
export * from "./planosSemestrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports